import React from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'

import { withFirebase } from '../Firebase'

import TextArea from './TextArea'
import ContentNodeTextInput from './ContentNodeTextInput'
import ImageDropArea from './ImageDropArea'
import Spinner from './Spinner'
import * as Content from '../reducers/Content'
import { uuidImageName } from '../helpers'

const CloseButton = (props) => (
  <div
    className="nodeContentCloseButton"
    onClick={(event) => {
      event.stopPropagation()
      props.onClick()
    }}
  >
    <img
      className="cross"
      src="/cross.svg"
      alt=""
      draggable="false"
      loading="lazy"
    />
  </div>
)

const DeleteButton = (props) => (
  <div
    className="nodeContentDeleteButton"
    onClick={(event) => {
      event.stopPropagation()
      props.onClick()
    }}
  >
    delete
  </div>
)

const Delimiter = (props) => <div className="nodeContentDelimiter" />

const Image = (props) => {
  const { uploading, image } = props
  const url = !uploading ? Content.imageURL(image) : ''
  return (
    <div className="nodeContentImage">
      {uploading ? (
        <Spinner />
      ) : (
        <img src={url} alt="" draggable="false" loading="lazy" />
      )}
    </div>
  )
}

const ModalViewOnly = ({
  title,
  type,
  text,
  image,
  onCloseButton,
  onClick,
}) => (
  <div className="nodeContentPanel" onClick={onCloseButton}>
    <div className="nodeContent" onClick={onClick}>
      <CloseButton onClick={onCloseButton} />
      <div className="nodeContentTitle">{title}</div>
      <Delimiter />
      <div className="nodeContentContainer">
        {type === 'image' ? <Image image={image} /> : text}
      </div>
    </div>
  </div>
)

var timeout = null
class NodeContent extends React.Component {
  componentDidMount() {
    if (this.textInputReference !== undefined) {
      !this.props.isViewOnly && this.textInputReference.focus()
    } else {
      !this.props.isViewOnly && this.titleInputReference.focus()
    }
  }

  onCloseButton = () => {
    this.props.endEditingContentNode()
  }

  onDeleteButton = () => {
    this.props.removeNode(this.props.node.id)
  }

  onClick = (event) => {
    event.stopPropagation()
  }

  onTitleChange = (title) => {
    const { node, setTitle } = this.props
    setTitle(node.id, title, true)
  }

  onTextChange = (text) => {
    const { node, setText, setTitle, firebase } = this.props
    setText(node.id, text, true)

    clearTimeout(timeout)
    timeout = setTimeout(async function () {
      const video = await firebase.getVideoSnippet(text)
      if (video !== null) {
        setTitle(node.id, video.title, true)
      }
    }, 1000)
  }

  saveTitleInputReference = (reference) => {
    this.titleInputReference = reference
  }

  saveTextInputReference = (reference) => {
    this.textInputReference = reference
  }

  onDropImage = (image) => {
    const { node, firebase, setUploadingImage, removeUploading } = this.props
    const imageName = uuidImageName(image)
    setUploadingImage(node.id, imageName)

    firebase
      .putImage(image, imageName)
      .then(function (snapshot) {
        removeUploading(imageName)
      })
      .catch(function (error) {
        removeUploading(imageName)
      })
  }

  render() {
    const { node, uploading, isViewOnly } = this.props
    const type = Content.nodeType(node)

    if (isViewOnly) {
      return (
        <ModalViewOnly
          title={node.title}
          text={node.text}
          image={node.image}
          type={type}
          onCloseButton={this.onCloseButton}
          onClick={this.onClick}
        />
      )
    }

    return (
      <div className="nodeContentPanel" onClick={this.onCloseButton}>
        <div className="nodeContent" onClick={this.onClick}>
          <CloseButton onClick={this.onCloseButton} />
          <DeleteButton onClick={this.onDeleteButton} />
          <ContentNodeTextInput
            text={node.title}
            placeholder="Title (optional)"
            onChange={this.onTitleChange}
            setRef={this.saveTitleInputReference}
          />
          <Delimiter />
          <ImageDropArea onDrop={this.onDropImage}>
            <div className="nodeContentContainer">
              {type === 'image' ? (
                <Image image={node.image} uploading={uploading} />
              ) : (
                <TextArea
                  text={node.text}
                  placeholder="Enter text or drop image"
                  onChange={this.onTextChange}
                  setRef={this.saveTextInputReference}
                />
              )}
            </div>
          </ImageDropArea>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  let uploading = false
  if (Content.isImageNode(ownProps.node)) {
    uploading = state.app.uploading[ownProps.node.image] ?? false
  }
  return {
    uploading,
  }
}

const ConnectedNodeContent = connect(mapStateToProps, actions)(NodeContent)

export default withFirebase(ConnectedNodeContent)
